import { shape, required, Validator, Failure, Success, ValidationError, concatFailure } from '@totalsoft/pure-validations';
import i18next from 'i18next';

export const contentTypeValidator = shape({
  name: required,
  code: required
});

export const contentTypeXMetadataValidator = metadataList =>
  [
    shape({
      contentTypeId: required,
      metadataId: required,
      mandatory: required
    }),
    uniqueItem(metadataList)
  ] |> concatFailure;

export const uniqueItem = metadataList =>
  Validator(metadataItem => {
    if (!metadataItem.metadataId || !metadataList) return Success;

    const duplicateMetadata = metadataList.find(x => x.metadataId === metadataItem.metadataId);

    return duplicateMetadata && duplicateMetadata.id !== metadataItem.id
      ? Failure(ValidationError(i18next.t('Metadata.DuplicateMetadataError')))
      : Success;
  });
